import React, { useEffect, useState } from "react";
import Header from "../../Layout/Header";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { allapiAction } from "../../../Redux/common/action";
import { Table } from "antd";
import moment from "moment";
import NewHeader from "../../Layout/NewHeader";
import NewSidebar from "../../Layout/NewSidebar";
function FundRequest() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const pagev = searchParams.get("page");
  const searchData = searchParams.get("search");

  const page = pagev == null ? 1 : pagev;
  const search = searchData == null ? "" : searchData;
  const [pages, setPage] = useState(1);
  const order_list = useSelector((state) =>
    state?.allapi?.get_withdrawal_requset_list
      ? state?.allapi?.get_withdrawal_requset_list
      : {}
  );
  const listdata = order_list?.docs ? order_list?.docs : [];

  useEffect(() => {
    // if (search) {
    //   dispatch(allapiAction.getSearchOrdervendor({ page: page, key: search }));
    // } else {
    dispatch(allapiAction.getaddfundListUser(page));
    // }
    // dispatch(allapiAction.getInvoceDetails());
    return () => {};
  }, [location]);

  const hendlePahegi = (e) => {
    setPage(e);

    console.log(location);

    navigate("/reacharge-list?page=" + e + "&&search=" + search);
  };
  const columns = [
    {
      title: "S.No.",
      dataIndex: "sno",
      key: "sno",
      className: "table_first_col",
      render: (value, item, index) => (page - 1) * 10 + index + 1,
    },

    {
      title: "Amount",
      dataIndex: "payablePayment",
      key: "payablePayment",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            {/* <Tooltip title="Contact"> */}
            <span
              className="cursor-pointer "
              // onClick={() => navigate(`/user-details/${item?.referId}`)}
            >
              {item?.amount}

              {/* <p> {item?.user_id?.referId}</p> */}
            </span>
          </>
        );
      },
    },
    {
      title: "Reason",
      dataIndex: "reason",
      key: "reason",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            {/* <Tooltip title="Contact"> */}
            <span
              className="cursor-pointer "
              // onClick={() => navigate(`/user-details/${item?.referId}`)}
            >
              {item?.reason}

              {/* <p> {item?.user_id?.referId}</p> */}
            </span>
          </>
        );
      },
    },

    {
      title: "Date",
      dataIndex: "createdAt",
      key: "createdAt",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            {/* <Tooltip title="Contact"> */}
            <span
              className="cursor-pointer"
              // onClick={() => navigate(`/users/contact/${item?.id}`)}
            >
              {moment(item?.createdAt).format(" DD/MM/YYYY ")}
            </span>
          </>
        );
      },
    },

    // {
    //   title: "Amount",
    //   dataIndex: "sub_total",
    //   key: "sub_total",
    // },
    // {
    //   title: "Payment Mode",
    //   dataIndex: "payment_mode_name",
    //   key: "payment_mode_name",
    // },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
    // {
    //   title: "Order return",
    //   dataIndex: "orderretune",
    //   key: "orderretune",
    //   className: "table_action_col",
    //   render: (value, item, index) => {
    //     return (
    //       <>
    //         <span
    //           className="cursor-pointer"
    //           // onClick={() => navigate(`/users/contact/${item?.id}`)}
    //         >
    //           {item?.orderretune == "true" ? "Yes" : "No"}
    //         </span>
    //       </>
    //     );
    //   },
    // },
    // {
    //   title: "Actions",
    //   dataIndex: "action",
    //   key: "action",
    //   className: "table_action_col",
    //   render: (value, item, index) => {
    //     return (
    //       <>

    //         <Tooltip title="Invoice">
    //           <button
    //             className="filter-button ml-3  mt-5"
    //             onClick={() => hendleToViewM(item)}
    //           >
    //             Invoice
    //           </button>
    //         </Tooltip>
    //         <Tooltip title="View">
    //           <button
    //             className="filter-button ml-3  mt-5"
    //             onClick={() => hendleToViewProduct(item)}
    //           >
    //             View
    //           </button>
    //         </Tooltip>

    //       </>
    //     );
    //   },
    // },
  ];
  return (
    <div>
    <NewHeader />
    <NewSidebar />
    <div className="main" style={{ minHeight: "100vh", paddingTop: "50px" }}>
      <div className="my" style={{ minHeight: "100vh" }}> {/* Add minHeight */}
        <div className="container mt-5 pt-5 mb-5 pb-5">
          <div className="tableResponsive mt-10">
            <Table
              className="table antd_table custom-table"
              dataSource={listdata}
              columns={columns}
              pagination={{
                current: parseInt(page),
                pageSize: 10,
                onChange(current, pageSize) {
                  hendlePahegi(current);
                },
                hideOnSinglePage: true,
                total: order_list?.totalDocs ? order_list?.totalDocs : 0,
              }}
            />
          </div>
        </div>
      </div>
      <style jsx="true">{`
        .my {
          background-image: linear-gradient(90deg, rgba(237, 204, 238, 0.9), rgba(162, 233, 202, 0.9), rgba(245, 247, 179, 0.9));
          background-color: rgba(255, 255, 255, 0.5); /* Transparent white background */
          background-blend-mode: overlay; /* Blend the background image with the color */
          min-height: 100vh; /* Ensure the height is enough to show the background */
        }
        .custom-table {
          background: #fff;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 5px 25px rgba(0, 0, 0, 0.1);
          margin-top: 20px;
          min-width: 800px; /* Table's min-width */
        }
        .custom-table .ant-table-thead > tr > th {
          background-color: #1c0f5c;
          color: #fff;
          font-weight: 600;
          font-size: 16px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          padding: 16px;
        }
        .custom-table .ant-table-tbody > tr > td {
          font-size: 15px;
          padding: 14px;
          background-color: #fafafa;
          border-bottom: 1px solid #eee;
        }
        .custom-table .ant-table-tbody > tr:hover > td {
          background-color: #f0f8ff;
          transition: all 0.3s;
        }
        .custom-table .ant-pagination {
          margin-top: 20px;
          text-align: center;
        }
        .tableResponsive {
          width: 100%;
          overflow-x: auto;
        }
        @media (max-width: 768px) {
          .custom-table {
            min-width: 600px;
          }
        }
        @media (max-width: 576px) {
          .custom-table {
            min-width: 500px;
          }
        }
      `}</style>
    </div>
    <div style={{ height: "100px" }}></div>
  </div>
  
  );
}

export default FundRequest;
